import * as uri from './uri'

// ------------------------------------------------------
// https://support.google.com/webmasters/answer/189077
// ------------------------------------------------------
// Update complete meta or at least
// blank to not show wrong data
// ---------------------------------
// { title, keywords, description }
export function tags( data ) {

  data = data || {}

  const head = {
    title: document.querySelector( "head title" ),
    keywords: document.querySelector( "head meta[name=keywords]" ),
    description: document.querySelector( "head meta[name=description]" ),
    ldjson: document.querySelector( `script[type="application/ld+json"]` )
  }

  if ( data.ldjson ) {
    // Add data to html for others to query
    // Make script easier accessible with script.json if data is available
    head.ldjson.classList.remove( "api" )
    try {
      head.ldjson.innerHTML = JSON.stringify( data.ldjson, null, 2 )
      if ( Object.keys( data.ldjson ).length > 0 ) {
        head.ldjson.classList.add( "api" )
      }
    } catch ( e ) {
      head.ldjson.innerHTML = "{}"
    }
  }

  if ( head.title ) {
    if( data.title ) {
      head.title.innerHTML = `${data.title} | epha.health`
    } else {
      head.title.innerHTML = ""
    }
  }

  if ( head.keywords ) {
    head.keywords.content = data.keywords || ""
  }

  if ( head.description ) {
    head.description.content = data.description || ""
  }

}

// ------------------------
// SEO for languages
// ------------------------
export function canonical( view, lang, navi, xeon = {} ) {
  // HTML lang attribute
  document.documentElement.lang = lang
  // Encode vars from xeon
  var url = uri.build( view, lang, xeon )
  // ---------------------------------------------
  // Set URL only for non manual navigation and
  // add xeon id only for view advice
  // ---------------------------------------------
  // The URL is now with encoded vars if available
  if ( navi == 'push' ) {
    history.pushState( "", null, url )
  }
  if ( navi == 'replace' ) {
    history.replaceState( "", null, url )
  }
  // --------------------------------------------------
  // Canoical links also specified in sitemap
  // --------------------------------------------------
  // Add deep linking for view advice for seo links
  $( "head link[rel=canonical]" ).href = location.href
  $( "head link[rel=canonical]" ).hreflang = lang
  $( "head link[rel=alternate][hreflang=de]" ).href = location.href.replace( `/${lang}/`, `/de/` )
  $( "head link[rel=alternate][hreflang=en]" ).href = location.href.replace( `/${lang}/`, `/en/` )
  $( "head link[rel=alternate][hreflang=fr]" ).href = location.href.replace( `/${lang}/`, `/fr/` )
  $( "head link[rel=alternate][hreflang=it]" ).href = location.href.replace( `/${lang}/`, `/it/` )
  $( "head link[rel=alternate][hreflang=es]" ).href = location.href.replace( `/${lang}/`, `/es/` )
  $( "head link[rel=alternate][hreflang=ru]" ).href = location.href.replace( `/${lang}/`, `/ru/` )
  $( "head link[rel=alternate][hreflang=pt]" ).href = location.href.replace( `/${lang}/`, `/pt/` )
  $( "head link[rel=alternate][hreflang=zh]" ).href = location.href.replace( `/${lang}/`, `/zh/` )
  $( "head link[hreflang=x-default]" ).href = location.href.replace( `/${lang}/`, `/en/` )

  // Deprecated due to Tag Manager history changes
  // if ( window.gtag ) {
  //   gtag( 'config', 'UA-9955206-2', { page_path: location.pathname } );
  //   gtag( 'config', 'GTM-PQ3T5W6', { page_path: location.pathname } );
  // }
}

// --------------------
// Crawler
// --------------------
export function robots( allow = false ) {
  if ( allow ) {
    $( "head meta[name=robots]" ).content = "index,follow"
  } else {
    $( "head meta[name=robots]" ).content = "noindex,nofollow"
  }
}
